import { Tool } from '../../types';

export const legalTools: Tool[] = [
  {
    id: 'docusign',
    name: 'DocuSign',
    category: 'Legal & Compliance',
    description: 'The world\'s leading electronic signature platform trusted by over 1 million customers. Send, sign, and manage legally binding agreements from anywhere. Bank-grade security, audit trails, and integrations with 400+ apps for streamlined workflows.',
    pricing: ['low', 'medium', 'high'],
    features: ['security', 'mobile', 'integrations'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['service-business', 'consulting-firm'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['finance', 'real-estate', 'consulting'],
    website: 'https://www.docusign.com',
    imageUrl: 'https://logo.clearbit.com/docusign.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'hellosign',
    name: 'HelloSign',
    category: 'Legal & Compliance',
    description: 'Simple, intuitive e-signature solution now part of Dropbox. Sign documents, request signatures, and create reusable templates with a clean, modern interface. Includes audit trails, team management, and seamless Dropbox integration.',
    pricing: ['low', 'medium'],
    features: ['ease-of-use', 'mobile', 'security'],
    bestFor: ['freelancer', 'small-business'],
    compatibleWith: ['service-business', 'consulting-firm'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['consulting', 'real-estate', 'finance'],
    website: 'https://www.hellosign.com',
    imageUrl: 'https://logo.clearbit.com/hellosign.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'pandadoc',
    name: 'PandaDoc',
    category: 'Legal & Compliance',
    description: 'All-in-one document automation platform combining proposals, quotes, contracts, and e-signatures. Features content library, CPQ functionality, and CRM integrations. Analytics dashboard tracks document engagement to help close deals faster.',
    pricing: ['low', 'medium'],
    features: ['automation', 'integrations', 'mobile'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['service-business', 'consulting-firm'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology', 'consulting', 'finance'],
    website: 'https://www.pandadoc.com',
    imageUrl: 'https://logo.clearbit.com/pandadoc.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];